import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54ba8a24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fd-header" }
const _hoisted_2 = { class: "fd-header-right" }

import { computed } from 'vue';
import Logo from './logo/index.vue';
import Sidebar from './sidebar/index.vue';
import Tags from './tags/index.vue';
import Screenfull from './screenfull/index.vue';
import Lang from './lang/index.vue';
import User from './user/index.vue';
import Setting from './setting/index.vue';
import { useLayoutStoreHook } from '@/store/modules/layout';
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons-vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const layoutStore = useLayoutStoreHook();
const toggle = () => {
  layoutStore.toggleAside();
};
const styleC = computed(() => {
  const { layout, opened } = layoutStore;
  if (layout === 'horizontal') {
    return { width: '100%' };
  }
  return {
    width: `calc(100% - ${opened ? '210px' : '54px'})`,
  };
});

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("header", {
    class: "fixed-header",
    style: _normalizeStyle(_unref(styleC))
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_unref(layoutStore).layout === 'horizontal')
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(Logo),
            _createVNode(Sidebar)
          ], 64))
        : (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            size: "small",
            onClick: toggle
          }, {
            default: _withCtx(() => [
              (_unref(layoutStore).opened)
                ? (_openBlock(), _createBlock(_unref(MenuUnfoldOutlined), { key: 0 }))
                : (_openBlock(), _createBlock(_unref(MenuFoldOutlined), { key: 1 }))
            ]),
            _: 1
          })),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(Screenfull),
        _createVNode(Lang),
        _createVNode(User),
        _createVNode(Setting)
      ])
    ]),
    _createVNode(Tags)
  ], 4))
}
}

})